import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { motion } from 'framer-motion'
import Navbar from './components/layout/Navbar'
import Sidebar from './components/layout/Sidebar'
import Dashboard from './pages/Dashboard'
import Leaderboard from './pages/Leaderboard'
import Community from './pages/Community'
import Trading from './pages/Trading'
import Profile from './pages/Profile'
import { useStore } from './store/useStore'

function App() {
  const { sidebarOpen } = useStore()

  return (
    <div className="min-h-screen bg-dark-950 text-white">
      <Navbar />
      <div className="flex">
        <Sidebar />
        <main 
          className={`flex-1 transition-all duration-300 ${
            sidebarOpen ? 'ml-64' : 'ml-16'
          } pt-16`}
        >
          <div className="container mx-auto px-4 py-8">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/community" element={<Community />} />
              <Route path="/trading" element={<Trading />} />
              <Route path="/profile" element={<Profile />} />
            </Routes>
          </div>
        </main>
      </div>
    </div>
  )
}

export default App 